export default __webpack_public_path__ + "static/media/shreya.d6dc7c9f.png";